export default __webpack_public_path__ + "static/media/orange-leaf.4e870cfc.svg";